import { Component, OnInit, viewChild, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule, NgClass, AsyncPipe } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DirectivesModule } from 'src/app/directives.module';
import { PaginationComponent } from 'ngx-bootstrap/pagination';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/public_api';
import { ActivatedRoute, Router } from '@angular/router';
import { TeacherJobsService } from 'src/app/services/api/consumer/jobs.service';
import { HttpClient } from '@angular/common/http';
import { co } from '@fullcalendar/core/internal-common';
import { PublicHeaderComponent } from 'src/app/layout/public-header/public-header.component';
import { ArticleComponent } from '../../producer/article/article.component';
import { Meta, Title } from '@angular/platform-browser';
import { SchoolData } from 'src/app/models/schoolUser';
import { CampAusHeaderComponent } from 'src/app/layout/camp-aus-header/camp-aus-header.component';
import { table } from 'console';
@Component({
  selector: 'app-jobs',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DirectivesModule, PublicHeaderComponent, PaginationComponent, ArticleComponent, CampAusHeaderComponent],
  templateUrl: './jobs.component.html',
  styleUrl: './jobs.component.scss'
})
export class JobsComponent {

  currentPage: number = 1;
  totalCount: number = 0;
  page: number = 1;
  public schoolProps!: SchoolData;

  isAuthenticated: boolean = false;
  is_camp_aus: any;
  isArrayAndIncludes(arr: any, value: any): boolean {
    return Array.isArray(arr) && arr.includes(value);
  }
  onSchoolTypeChange(event: any, value: string) {
    const schoolTypeArray = this.jobsFiltersForm.get('school_type');
    if (!schoolTypeArray) return;
    let arr = schoolTypeArray.value as string[];
    if (event.target.checked) {
      if (!arr.includes(value)) {
        schoolTypeArray.setValue([...arr, value]);
      }
    } else {
      schoolTypeArray.setValue(arr.filter(v => v !== value));
    }
    schoolTypeArray.updateValueAndValidity();
  }
  onJobTypeChange(event: any, value: string) {
    const jobTypeArray = this.jobsFiltersForm.get('job_type');
    if (!jobTypeArray) return;
    // If jobTypeArray is a FormArray, use its methods
    if (Array.isArray(jobTypeArray.value)) {
      let arr = jobTypeArray.value as string[];
      if (event.target.checked) {
        if (!arr.includes(value)) {
          jobTypeArray.patchValue([...arr, value]);
        }
      } else {
        jobTypeArray.patchValue(arr.filter(v => v !== value));
      }
      jobTypeArray.updateValueAndValidity();
    } else if (jobTypeArray.push && jobTypeArray.removeAt) {
      // If jobTypeArray is a FormArray instance
      const idx = jobTypeArray.controls.findIndex((ctrl: any) => ctrl.value === value);
      if (event.target.checked && idx === -1) {
        jobTypeArray.push(this.fb.control(value));
      } else if (!event.target.checked && idx > -1) {
        jobTypeArray.removeAt(idx);
      }
      jobTypeArray.updateValueAndValidity();
    }
  }
  appliedFilterChips: Array<{ key: string, value: any, label: string }> = [];
  jobsFiltersForm: any;
  invitesSubject: any;
  schoolLengthLimit: any;
  teacherProfile: any;
  activeTab: 'all-jobs' | 'saved' | 'applied' = 'all-jobs';
  schoolInvitesHistoryFilterForm: FormGroup;
  schoolInvitesPendingFilterForm: FormGroup;
  jobData: any[] = [];
  historyData: any[] = [];
  pendingData: any[] = [];

  jobTypes = [
    { value: 'FT', code: 'FULL_TIME', label: 'Full Time' },
    { value: 'PT', code: 'PART_TIME', label: 'Part Time' },
    { value: 'C', code: 'CASUAL', label: 'Casual' },
    { value: 'CO', code: 'CONTRACT', label: 'Contract' },
    { value: 'JS', code: 'JOB_SHARE', label: 'Job Share' }
  ];

  sideComponentData: {
    actively_hire_school?: any[],
    early_applicant?: any[],
    saved_expire?: any[]
  } = {};
  schoolTypes = [
    { value: 'C', code: 'CATHOLIC', label: 'Catholic' },
    { value: 'G', code: 'GOVERNMENT', label: 'Government' },
    { value: 'P', code: 'PRIVATE', label: 'Private' },
    { value: 'S', code: 'SPECIAL', label: 'Special' },
    { value: 'EC', code: 'EDUCATION_COMPANY', label: 'Education Company' }
  ];

  loading: boolean = false;
  constructor(
    public ngxService: NgxUiLoaderService,
    private fb: FormBuilder,
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private router: Router,
    private TeacherJobsService: TeacherJobsService,
    private http: HttpClient,
    private meta: Meta,
    private titleService: Title
  ) {

    this.jobsFiltersForm = this.fb.group({
      global_search: [''],
      address_search: [''],
      job_type: this.fb.control([]),
      is_camp_aus: [false],
      school_type: this.fb.control([]), // Use FormControl for array of values
      job_distance: ['10000000'],
      postedWithin: [''],
      schoolSize: [''],
      page: [1],
      tab: ['']
    });
    this.schoolInvitesHistoryFilterForm = this.fb.group({
      title: [''],
    });
    this.schoolInvitesPendingFilterForm = this.fb.group({
      title: [''],
    });
  }
  ngOnInit(): void {
    this.metaOGTags();
    // Check for access_token and refresh_token in cookies for authentication
    const getCookie = (name: string) => {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    };
    const accessToken = getCookie('access_token');
    const refreshToken = getCookie('refresh_token');
    this.isAuthenticated = !!(accessToken && refreshToken);
    if (this.isAuthenticated) {
      this.sideComponent()
    }
    this.schoolProps = JSON.parse(localStorage.getItem("userData") || '{}');
    this.is_camp_aus = this.schoolProps?.properties?.is_camp_aus;

    // Set default tab from URL or default to 'all-jobs'
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');
    const campAus = urlParams.get('job_type');
    if (campAus === 'campAustraliaJobs') {
      this.jobsFiltersForm.patchValue({ is_camp_aus: 1 });
    } else {
      this.jobsFiltersForm.patchValue({ is_camp_aus: 0 });
    }
    let filters = this.jobsFiltersForm.getRawValue();
    filters.page = this.page;
    if (tabParam === 'saved') {
      this.activeTab = 'saved';
      this.loadPendingWithFilters(filters);
    } else if (tabParam === 'applied') {
      this.activeTab = 'applied';
      this.loadHistoryWithFilters(filters);
    } else {
      this.activeTab = 'all-jobs';
      this.loadInvitesWithFilters(filters);
    }
  }
  metaOGTags() {
    this.titleService.setTitle('ClassCover Jobs | Teaching Jobs | ClassCover Jobs');
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: 'URL_TO_CLASSCOVER_JOBS_LOGO' }); // Replace with actual logo URL
    this.meta.updateTag({ property: 'og:title', content: 'ClassCover Jobs | Teaching Jobs | ClassCover Jobs' });
    this.meta.updateTag({ property: 'og:description', content: 'Find jobs in education with ClassCover Jobs. Browse thousands of jobs near you and right around Australia. New jobs added every day.' });
    this.meta.updateTag({ property: 'og:site_name', content: 'ClassCover Jobs' });
  }
  sideComponent() {
    // Load invites data
    this.loading = true;
    this.ngxService.start();
    this.TeacherJobsService
      .sideComponentAPI()
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.sideComponentData = res.data || {};
            console.log(this.sideComponentData);
            this.ngxService.stop();
            this.loading = false;
          } else {
            this.toastr.error(res.message || 'Failed to load jobs');
            this.ngxService.stop();
            this.loading = false;
          }
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load jobs');
          this.ngxService.stop();
        },
      });
  }
  applyFilters(filterType: 'filter' | 'global_search' = 'filter', isCampAusButton: any = '') {
    if (isCampAusButton === 'camp_aus') {
      this.router.navigate([], { queryParams: { tab: 'all', job_type: 'campAustraliaJobs' }, queryParamsHandling: 'merge' });
      this.jobsFiltersForm = this.fb.group({
        global_search: [''],
        address_search: [''],
        job_type: this.fb.control([]),
        is_camp_aus: [false],
        school_type: this.fb.control([]), // Use FormControl for array of values
        job_distance: ['10000000'],
        postedWithin: [''],
        schoolSize: [''],
        page: [1],
        tab: [this.activeTab]
      });
      this.jobsFiltersForm.patchValue({ is_camp_aus: 1 });
    }
    if (isCampAusButton === 'regularJobs') {
      this.router.navigate([], { queryParams: { tab: 'all' } });
      this.jobsFiltersForm = this.fb.group({
        global_search: [''],
        address_search: [''],
        job_type: this.fb.control([]),
        is_camp_aus: [false],
        school_type: this.fb.control([]), // Use FormControl for array of values
        job_distance: ['10000000'],
        postedWithin: [''],
        schoolSize: [''],
        page: [1],
      });
      this.jobsFiltersForm.patchValue({ is_camp_aus: 0 });
    }
    const formValue = this.jobsFiltersForm.value;
    if (
      formValue.address_search != '' &&
      (!formValue.job_distance || formValue.job_distance === '10000000')
    ) {
      this.jobsFiltersForm.patchValue({ job_distance: '250' });
    }
    // job_type is now an array of selected values
    const selectedJobTypes = this.jobTypes.filter(type => Array.isArray(formValue.job_type) && formValue.job_type.includes(type.value));
    const selectedSchoolTypes = this.schoolTypes.filter(type => Array.isArray(formValue.school_type) && formValue.school_type.includes(type.value));
    // Build payload and always send all keys, never send null (use '' or [] instead)
    const filters: any = {
      global_search: formValue.global_search ?? '',
      address_search: formValue.address_search ?? '',
      job_type: Array.isArray(formValue.job_type) ? formValue.job_type : [],
      school_type: Array.isArray(formValue.school_type) ? formValue.school_type : [],
      job_distance: formValue.job_distance ?? '10000000',
      posted_within: formValue.postedWithin ?? '',
      school_size: formValue.schoolSize ?? '',
      filter_type: filterType
    };

    // Build chips for applied filters (show each value separately, no label prefix)
    const chips: Array<{ key: string, value: any, label: string }> = [];
    if (filters.search) chips.push({ key: 'search', value: filters.search, label: `${filters.search}` });
    // if (filters.address_search) chips.push({ key: 'address_search', value: filters.address_search, label: `${filters.address_search}` });
    if (selectedJobTypes.length > 0) {
      selectedJobTypes.forEach(type => {
        chips.push({ key: 'job_type', value: type.value, label: String(type.label) });
      });
    }
    if (selectedSchoolTypes.length > 0) {
      selectedSchoolTypes.forEach(type => {
        chips.push({ key: 'school_type', value: type.value, label: type.label });
      });
    }
    if (filters.job_distance && filters.job_distance !== '10000000') {
      chips.push({ key: 'job_distance', value: filters.job_distance, label: `${filters.job_distance} km` });
    }
    if (filters.posted_within) chips.push({ key: 'postedWithin', value: filters.posted_within, label: `Last ${filters.posted_within} days` });
    if (filters.school_size) chips.push({ key: 'schoolSize', value: filters.school_size, label: `${filters.school_size}` });
    this.appliedFilterChips = chips;
    // Load invites data
    this.loading = true;
    this.ngxService.start();
    let rawFormValue = this.jobsFiltersForm.getRawValue();
    rawFormValue.page = this.page;
    this.TeacherJobsService
      .teacherJobsAPI(rawFormValue)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.jobData = res?.data?.job || [];
            this.all_jobs_tab = true
            this.saved_jobs_tab = false
            this.applied_jobs_tab = false
            console.log(this.jobData);
            this.schoolLengthLimit = res?.data?.total_count || 0;
            this.totalCount = parseInt(res?.data?.page_count) * 10;

            this.ngxService.stop();
          } else {
            this.toastr.error(res.message || 'Failed to load jobs');
            this.ngxService.stop();
          }
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load jobs');
          this.ngxService.stop();
          this.loading = false;
        },
      });
  }

  removeFilterChip(chip: { key: string, value: any, label: string }) {
    // Remove the filter from the form and re-apply filters
    if (chip.key === 'job_type') {
      const jobTypeArray = this.jobsFiltersForm.get('job_type');
      if (jobTypeArray && jobTypeArray.value && Array.isArray(jobTypeArray.value)) {
        const idx = jobTypeArray.value.indexOf(chip.value);
        if (idx > -1) {
          jobTypeArray.value.splice(idx, 1);
          jobTypeArray.updateValueAndValidity();
        }
      }
    } else if (chip.key === 'school_type') {
      const schoolTypeArray = this.jobsFiltersForm.get('school_type');
      if (schoolTypeArray && schoolTypeArray.value && Array.isArray(schoolTypeArray.value)) {
        const idx = schoolTypeArray.value.indexOf(chip.value);
        if (idx > -1) {
          schoolTypeArray.setValue(schoolTypeArray.value.filter((v: string) => v !== chip.value));
          schoolTypeArray.updateValueAndValidity();
        }
      }
    } else if (
      chip.key === 'search' ||
      chip.key === 'address_search' ||
      chip.key === 'job_distance' ||
      chip.key === 'postedWithin' ||
      chip.key === 'schoolSize'
    ) {
      this.jobsFiltersForm.get(chip.key)?.setValue('');
    }
    // Re-apply filters after removal
    const urlParams = new URLSearchParams(window.location.search);
    const campAus = urlParams.get('job_type');
    if (campAus === 'campAustraliaJobs') {
      this.applyFilters('filter', 'camp_aus');
    } else {
      this.applyFilters();
    }
  }
  all_jobs_tab: boolean = false;
  saved_jobs_tab: boolean = false;
  applied_jobs_tab: boolean = false;
  loadInvites() {
    // Load invites data
    this.ngxService.start();
    const formValue = this.jobsFiltersForm.getRawValue();
    formValue.page = this.page;
    this.TeacherJobsService
      .teacherJobsAPI(formValue)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.jobData = res?.data?.job || [];
            this.all_jobs_tab = true
            this.saved_jobs_tab = false
            this.applied_jobs_tab = false
            console.log(this.jobData);
            this.schoolLengthLimit = res?.data?.total_count || 0;
            this.totalCount = parseInt(res?.data?.page_count) * 10;

            this.ngxService.stop();
          } else {
            this.toastr.error(res.message || 'Failed to load jobs');
            this.ngxService.stop();
          }
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load jobs');
          this.ngxService.stop();
          this.loading = false;
        },
      });
  }
  loadHistory() {
    this.jobsFiltersForm.reset({
      global_search: '',
      address_search: '',
      job_type: [],
      school_type: [],
      job_distance: '10000000',
      postedWithin: '',
      schoolSize: '',
    });
    this.schoolInvitesPendingFilterForm.reset({
      title: '',
    });

    this.loading = true;
    this.ngxService.start();
    const formValue = this.jobsFiltersForm.getRawValue();
    formValue.page = this.page;

    this.TeacherJobsService
      .appliedJobs(formValue)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.jobData = res?.data?.applied_job || [];
            this.all_jobs_tab = false
            this.saved_jobs_tab = false
            this.applied_jobs_tab = true
            this.schoolLengthLimit = res?.data?.total_count || 0;
            this.totalCount = parseInt(res?.data?.page_count) * 10;
            console.log(this.jobData);
            console.log(this.totalCount);

            this.ngxService.stop();
          } else {
            this.toastr.error(res.message || 'Failed to load history');
            this.ngxService.stop();
          }
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load history');
          this.ngxService.stop();
          this.loading = false;
        },
      });
  }
  // Load pending data
  loadPending() {
    this.jobsFiltersForm.reset({
      global_search: '',
      address_search: '',
      job_type: [],
      school_type: [],
      job_distance: '10000000',
      postedWithin: '',
      schoolSize: '',
    });
    this.ngxService.start();
    this.schoolInvitesHistoryFilterForm.reset({
      title: '',
    });
    const formValue = this.jobsFiltersForm.getRawValue();
    formValue.page = this.page;

    this.TeacherJobsService
      .savedJobs(formValue)
      .subscribe({
        next: (res: any) => {
          this.jobData = res?.data.saved_job || [];
          console.log(this.jobData);
          this.all_jobs_tab = false
          this.saved_jobs_tab = true
          this.applied_jobs_tab = false
          this.schoolLengthLimit = res?.data?.total_count || 0;
          this.totalCount = parseInt(res?.data?.page_count) * 10;
          this.ngxService.stop();
          this.loading = false;
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load history');
          this.ngxService.stop();
        },
      });
  }

  // Unified tab switch handler
  onTabChange(tab: 'all-jobs' | 'saved' | 'applied') {
    this.activeTab = tab;
    this.page = 1;
    // Update tab param in URL
    let tabParam = 'all';
    if (tab === 'saved') tabParam = 'saved';
    else if (tab === 'applied') tabParam = 'applied';
    this.router.navigate([], { queryParams: { tab: tabParam }, queryParamsHandling: 'merge' });

    // Always preserve filters
    let filters = this.jobsFiltersForm.getRawValue();
    filters.page = this.page;
    if (tab === 'all-jobs') {
      this.loadInvitesWithFilters(filters);
    } else if (tab === 'applied') {
      this.loadHistoryWithFilters(filters);
    } else if (tab === 'saved') {
      this.loadPendingWithFilters(filters);
    } else {
      this.loadInvitesWithFilters(filters);
    }
  }

  loadInvitesWithFilters(filters: any) {
    this.loading = true;
    this.ngxService.start();
    this.TeacherJobsService
      .teacherJobsAPI(filters)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.jobData = res?.data?.job || [];
            this.all_jobs_tab = true;
            this.saved_jobs_tab = false;
            this.applied_jobs_tab = false;
            this.schoolLengthLimit = res?.data?.total_count || 0;
            this.totalCount = parseInt(res?.data?.page_count) * 10;
          } else {
            this.toastr.error(res.message || 'Failed to load jobs');
          }
          this.ngxService.stop();
          this.loading = false;
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load jobs');
          this.ngxService.stop();
          this.loading = false;
        }
      });
  }

  loadHistoryWithFilters(filters: any) {
    this.jobsFiltersForm.patchValue({
      global_search: filters.global_search || '',
      address_search: filters.address_search || '',
      job_type: filters.job_type || [],
      school_type: filters.school_type || [],
      job_distance: filters.job_distance || '10000000',
      postedWithin: filters.postedWithin || '',
      schoolSize: filters.schoolSize || '',
    });
    this.schoolInvitesPendingFilterForm.reset({ title: '' });
    this.ngxService.start();
    this.TeacherJobsService
      .appliedJobs(filters)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.jobData = res?.data?.applied_job || [];
            this.all_jobs_tab = false;
            this.saved_jobs_tab = false;
            this.applied_jobs_tab = true;
            this.schoolLengthLimit = res?.data?.total_count || 0;
            this.totalCount = parseInt(res?.data?.page_count) * 10;
          } else {
            this.toastr.error(res.message || 'Failed to load history');
          }
          this.ngxService.stop();
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load history');
          this.ngxService.stop();
        }
      });
  }

  loadPendingWithFilters(filters: any) {
    this.jobsFiltersForm.patchValue({
      global_search: filters.global_search || '',
      address_search: filters.address_search || '',
      job_type: filters.job_type || [],
      school_type: filters.school_type || [],
      job_distance: filters.job_distance || '10000000',
      postedWithin: filters.postedWithin || '',
      schoolSize: filters.schoolSize || '',
    });
    this.ngxService.start();
    this.schoolInvitesHistoryFilterForm.reset({ title: '' });
    this.TeacherJobsService
      .savedJobs(filters)
      .subscribe({
        next: (res: any) => {
          this.jobData = res?.data?.saved_job || [];
          this.all_jobs_tab = false;
          this.saved_jobs_tab = true;
          this.applied_jobs_tab = false;
          this.schoolLengthLimit = res?.data?.total_count || 0;
          this.totalCount = parseInt(res?.data?.page_count) * 10;
          this.ngxService.stop();
        },
        error: (err: any) => {
          this.toastr.error(err.message || 'Failed to load history');
          this.ngxService.stop();
        }
      });
  }
  jobSaveUnsaveAPI(jobId: any, action: string): void {
    this.ngxService.start();
    this.TeacherJobsService.jobSaveUnsaveAPI(jobId, action).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.toastr.success(res.message);
          this.loadInvites();
          this.ngxService.stop();
        } else {
          this.toastr.error(res.message);
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        this.ngxService.stop();
        console.log(err);
      },
    });
  }

  sampleApiCall() {
    const formValue = this.jobsFiltersForm.value;
    // You can adjust the endpoint URL as needed
    const url = 'https://jsonplaceholder.typicode.com/posts';
    this.http.post(url, formValue).subscribe({
      next: (res) => {
        console.log('Sample API response:', res);
        this.toastr.success('Sample API call successful!');
      },
      error: (err) => {
        console.error('Sample API error:', err);
        this.toastr.error('Sample API call failed!');
      }
    });
  }
  // ...existing code...

  removeAllFiler() {
    const emptyValues: any = {};
    Object.keys(this.jobsFiltersForm.controls).forEach(key => {
      if (key === 'job_type' || key === 'school_type') {
        emptyValues[key] = [];
      } else if (key === 'job_distance') {
        emptyValues[key] = '10000000';
      } else {
        emptyValues[key] = '';
      }
    });
    this.jobsFiltersForm.reset(emptyValues);
    const urlParams = new URLSearchParams(window.location.search);
    const campAus = urlParams.get('job_type');
    if (campAus === 'campAustraliaJobs') {
      this.applyFilters('filter', 'camp_aus');
    } else {
      this.applyFilters();
    }
  }
  openJobDetails(item: any, from: string) {
    if (from === 'Expired') {
      return; // Do not navigate if the job is expired
    }
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab') || 'all';
    const campAus = urlParams.get('job_type');
    if (this.isAuthenticated) {
      if (campAus === 'campAustraliaJobs') {
        this.router.navigate(['/teacher/job-details', item.id], { queryParams: { fromTab: 'campAustraliaJobs' } });
      } else {
        this.router.navigate(['/teacher/job-details', item.id], { queryParams: { fromTab: tabParam } });
      }
    } else {
      this.router.navigate(['/job-details', item.id], { queryParams: { fromTab: tabParam } });
    }
  }
  openAppliedJobDetails(item: any) {
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab') || 'applied';
    this.router.navigate(['/teacher/job-details', item.job.id], { queryParams: { from: 'apply', fromTab: tabParam } });
  }
  openSavedJobDetails(item: any, from: string) {
    if (from === 'Expired') {
      return; // Do not navigate if the job is expired
    }
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab') || 'saved';
    this.router.navigate(['/teacher/job-details', item.job.id], { queryParams: { fromTab: tabParam } });
  }
  pageChanged(event: PageChangedEvent): void {
    this.page = event.page;
    // Call the correct API based on activeTab for pagination
    if (this.activeTab === 'all-jobs') {
      this.loadInvites();
    } else if (this.activeTab === 'applied') {
      this.loadHistory();
    } else if (this.activeTab === 'saved') {
      this.loadPending();
    } else {
      this.loadInvites();
    }
    window.scrollTo(0, 0); // Scroll to top on page change
  }
  handlePageData(data: any) {
    // Store the page data for later use, e.g. pagination or display
    this.pageData = data;
    // Optionally, update the UI or trigger other logic if needed
    // Example: this.obsArray.next(data.consumer_list || []);
  }
  pageData: any;
  redirectToSaveTab(id: string, tabParam: string) {
    this.router.navigate(['/teacher/job-details', id], { queryParams: { fromTab: tabParam } });
  }
  goToTeacherSettings() {
    this.router.navigate(['/teacher/settings']);
  }
}


